<template>
  <GmapMap ref="mapRef" :center="center"
           :zoom="zoom"
           map-type-id="terrain" @click="didClick"
           v-bind:style="'width:' + width + '; height:' + height"
           :options="{
             zoomControl: true,
             mapTypeControl: false,
             scaleControl: false,
             streetViewControl: false,
             rotateControl: false,
             fullscreenControl: true,
             disableDefaultUi: false
           }">
    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      //your custom html components
      <button type="button"
              style="background-color: pink;">
        Hello!
      </button>
      <ul>
        <li>
          List Item
        </li>
        <li>
          Another One
        </li>
      </ul>
    </gmap-info-window>

    <GmapMarker :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                :icon="m.icon"
                @click="toggleInfoWindow(m,i)" />
  </GmapMap>3
</template>

<script>

  var center = { lat: 10, lng: 10 };
  var map = null;

  var markers = [
    
  ];

  var zoom = 7;

  const iconBase =
    "https://developers.google.com/maps/documentation/javascript/examples/full/images/";

  const icons = {
    parking: {
      icon: iconBase + "parking_lot_maps.png",
    },
    library: {
      icon: iconBase + "library_maps.png",
    },
    info: {
      icon: iconBase + "info-i_maps.png",
    },
  };


export default {
  name: "map-component",
  components: {
    
    },
    props: {
      width: {
        required: false,
        type: String,
        default: '600px'
      },
      height: {
        required: false,
        type: String,
        default: '400px'
      },
      zoomlevel: {
        required: false,
        type: Number,
        default: 7
      },
    },
    data() {
      return {
        center,
        markers,
        lines: [],
        zoom: this.zoomlevel,
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: true,
        currentMidx: null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        map
      }
    },
    methods: {
      didClick(ev) {
        var lat = ev.latLng.lat();
        var lng = ev.latLng.lng();
        this.$emit("clicked_on_map", lat, lng )
      },
    changeMarkers() {
      
      this.markers = [{
        id: "a",
        position: { lat: 3, lng: 101 },
        icon: { url: icons["info"].icon }

      },
      {
        id: "b",
        position: { lat: 5, lng: 99 },
        icon: { url: icons["parking"].icon },
      },
        {
          id: "c",
          position: { lat: 6, lng: 97 },
          icon: { url: icons["library"].icon }
      }]
      },

      clearMarkers() {
        for (var i = 0; i < this.markers.length; i++) {
          this.markers[i].gMarker.setMap(null);
        }
        this.markers = [];
        Vue.set(this, "markers", this.markers);
      },

      setMarkers(markers) {
        this.clearMarkers();
        var map = this.map;
        for (var i = 0; i < markers.length; i++) {
          markers[i].gMarker = new google.maps.Marker({
            position: markers[i].position,
            map,
            title: "",
          });
          this.markers = markers;
        }
    },
    setCenter(lat, long) {
      this.center = { lat: lat, lng: long }
    },
    centerMyPosition() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setCenter(position.coords.latitude, position.coords.longitude)
      });
    },
    centerOnAddress(address) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, (results, status) => {
        if (status === 'OK') {
          this.setCenter(results[0].geometry.location.lat(), results[0].geometry.location.lng())
        }
      });
    },
    setZoom(zoom) {
      this.zoom = zoom;
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      //this.infoContent = marker.infoText;
      //this.infoContent = "bertil";
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    }
  },
  computed: {
    
  },
    async mounted() {
      //var thisContext = this;
      await this.$gmapApiPromiseLazy(); // Ensures that google map is loaded
      //this.centerOnAddress("thailand");
      //setTimeout(this.changeMarkers, 5000);
      //setTimeout(function () { thisContext.setZoom(2)}, 15000);

      var thisContext = this;
      this.$refs.mapRef.$mapPromise.then((map) => {
        thisContext.map = map;
      })
      
  }
};
</script>



// WEBPACK FOOTER //
// src/components/maps/Map-component.vue